
<view-linkable :content-element="contentElement" :entry="entry">
  <blank-fallback :is-blank="isBlank(value)">
    {{value}}
  </blank-fallback>
</view-linkable>
